import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as actions from "../../store/actions";
import { bindActionCreators } from "redux";
import { apiService } from "../../services/api.service";
import PositiveIncidentModal from "../../shared/components/ui/modal/positiveincident-modal";
import { Link } from "react-router-dom";
import FormatDateTime from "../../shared/components/functional/DateTimeFormatter";

class PositiveIncidents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kioskPositiveIncidents: [],
      loading: true,
    };
  }
  close = () => {
    this.setState({ showModal: false, kioskPositiveIncident: {} });
  };
  open = (e, kioskPositiveIncident) => {
    e.preventDefault();
    this.setState({ showModal: true, kioskPositiveIncident: kioskPositiveIncident });
  };
  GetPositiveIncidents = () => {
    const { auth } = this.props;

    apiService
      .post("GETPOSITIVEINCIDENTS", {
        Id: -1,
        ClientId: auth.user.ClientId,
        Days: 7,
      })
      .then(
        (response) => {
          if (response.Success && response.positiveIncidentsList) {
            this.setState({
              kioskPositiveIncidents: response.positiveIncidentsList,
            });
          }
          this.setState({ loading: false });
        },
        (error) => {
          this.props.actions.showAlert({ message: error, variant: "error" });
          this.setState({ loading: false });
        }
      );
  };
  componentDidMount() {
    this.GetPositiveIncidents();
  }
  render() {
    const {
      kioskPositiveIncidents,
      kioskPositiveIncident,
      loading,
      showModal,
    } = this.state;
    return (
      <Fragment>
        <div className="card">
          <div className="card-header positiveincident">
            <div className="icon">
              <i className="fa fa-bullhorn"></i>
            </div>
            Positive Incidents <small>Recently awarded PIRs</small>
            <div className="arrowRight">
              <Link className="active" to={`/PositiveIncidents`}>
                <i className="fa fa-arrow-right"></i>
              </Link>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table tableBodyScroll">
                <tbody>
                  {!loading &&
                    (kioskPositiveIncidents.length > 0 ? (
                      kioskPositiveIncidents.map((kioskPositiveIncident) => (
                        <tr key={kioskPositiveIncident.Id}>
                          <td>{kioskPositiveIncident.IncidentType} ({<FormatDateTime date={kioskPositiveIncident.IncidentDateTime} format="MM/DD/YYYY" />})</td>
                          <td className="text-right">
                            <i
                              className="fa fa-info"
                              aria-hidden="true"
                              onClick={(e) => this.open(e, kioskPositiveIncident)}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td>No positive incidents in the past 7 days</td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {loading && (
                <div className="loaderDiv">
                  <div className="loader">
                    <CircularProgress />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <PositiveIncidentModal
          onClose={this.close}
          positiveincident={kioskPositiveIncident}
          showModal={showModal}
        />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      showAlert: bindActionCreators(actions.showAlert, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PositiveIncidents);
